module.exports = __webpack_public_path__ + "static/img/GovernmentAffairs.907947b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/GovernmentAffairs.png
// module id = MmVl
// module chunks = 44